import { render, staticRenderFns } from "./BlockType24.vue?vue&type=template&id=7d9cbe5a&scoped=true"
import script from "./BlockType24.vue?vue&type=script&lang=ts"
export * from "./BlockType24.vue?vue&type=script&lang=ts"
import style0 from "./BlockType24.vue?vue&type=style&index=0&id=7d9cbe5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9cbe5a",
  null
  
)

export default component.exports